// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill"
import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import router from './router'
import store from './store'
import 'common/stylus/index.styl'
import utils from './common/js/utils.js'
import getUrl from './common/js/getUrl'
import Axios from 'axios'
import 'url-search-params-polyfill';
// https://stackoverflow.com/questions/39043816/how-to-properly-polyfill-urlsearchparams-in-webpack

//https://www.npmjs.com/package/v-viewer
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);
Viewer.setDefaults({
  Options: { "inline": false, "button": true, "navbar": false, "title": false, "toolbar": true, "tooltip": true, "movable": false, "zoomable": true, "rotatable": true, "scalable": false, "transition": true, "fullscreen": true, "keyboard": false}
});

Vue.prototype.$http = Axios;
Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.prototype.$utils=utils;
Vue.prototype.$getUrl=getUrl;

//Vue复制粘贴
//https://github.com/Inndy/vue-clipboard2
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import VueI18n from 'vue-i18n'
Vue.use(VueI18n) // 通过插件的形式挂载

//https://github.com/danieldiekmeier/vue-slide-up-down
import SlideUpDown from 'vue-slide-up-down'
Vue.component('slide-up-down', SlideUpDown)
const i18n = new VueI18n({
  locale: 'zh-CN', // 语言标识
  messages: {
    'zh-CN': require('./common/lang/zh'), // 中文语言包
    'en-US': require('./common/lang/en') // 英文语言包
  }
})

import global_ from './components/globalvalue/GlobalValue'//引用文件
Vue.prototype.GLOBAL = global_//挂载到Vue实例上面


/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js